import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LayerService } from '../../../services/layer.service';
import { LayerCatalogService } from '../../../services/layerCatalog.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var ExternalLayerCatalogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExternalLayerCatalogComponent, _super);
    function ExternalLayerCatalogComponent(_vcr, layerService, layerCatalogService, _formBuilder, cdr, loggingService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.layerService = layerService;
        _this.layerCatalogService = layerCatalogService;
        _this._formBuilder = _formBuilder;
        _this.cdr = cdr;
        _this.loggingService = loggingService;
        _this.onclose = new EventEmitter();
        _this.isLoading = false;
        _this.loadingLayers = false;
        _this.errorLoadingLayers = null;
        _this.catalogItems = [];
        _this.filteredCatalogItems = [];
        _this.searchInputControl = new FormControl();
        _this.mapServerFolders = [];
        _this.debounceTime = 500;
        _this.selectedLayers = [];
        _this.registerEvent('onclose', _this.onclose);
        _this.searchInputForm = _this._formBuilder.group({
            searchInput: _this.searchInputControl
        });
        return _this;
    }
    Object.defineProperty(ExternalLayerCatalogComponent.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            if (value) {
                this.onActivate();
            }
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    ExternalLayerCatalogComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.isReady();
                        this.searchInputControl
                            .valueChanges
                            .pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function () {
                            _this.filteredCatalogItems = _this.filterCatalogItems(_this.catalogItems);
                            _this.cdr.detectChanges();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ExternalLayerCatalogComponent.prototype.onActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rawData, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ready];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, 5, 6]);
                        this.errorLoadingLayers = null;
                        this.isLoading = true;
                        this.cdr.detectChanges();
                        return [4 /*yield*/, this.layerCatalogService.getExternalLayers()];
                    case 3:
                        rawData = _a.sent();
                        if (rawData) {
                            this.featureLayerCatalog = JSON.parse(rawData);
                            this.processLayerCatalog();
                            this.filteredCatalogItems = this.filterCatalogItems(this.catalogItems);
                            if (this.featureLayerCatalog.loading && !this.catalogItems.length) {
                                this.errorLoadingLayers = 'External layer catalog is refreshing. This can take a few minutes.';
                            }
                            else if (this.featureLayerCatalog.loading && this.catalogItems.length) {
                                this.errorLoadingLayers = 'The layers listed here could be out of date, as the external layer catalog is still being refreshed on the server.';
                                if (this.featureLayerCatalog.updatedOn) {
                                    this.errorLoadingLayers += " The last update was " + new Date(this.featureLayerCatalog.updatedOn).toLocaleString() + ".";
                                }
                            }
                        }
                        else {
                            this.errorLoadingLayers = 'An error occured while retrieving the external layer catalog. Error: No results from API';
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        error_1 = _a.sent();
                        // Occasional server task error, eat error and let user retry
                        this.errorLoadingLayers = "An error occured while retrieving the external layer catalog. Error: " + error_1.message;
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ExternalLayerCatalogComponent.prototype.processLayerCatalog = function () {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e, e_6, _f;
        this.catalogItems = [];
        if (this.featureLayerCatalog.mapServers) {
            try {
                for (var _g = tslib_1.__values(this.featureLayerCatalog.mapServers), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var mapServer = _h.value;
                    var catalogItem = {
                        expanded: false,
                        isSelected: false,
                        name: mapServer.name,
                        layerCatalogItems: []
                    };
                    if (mapServer.mapServerFolders) {
                        try {
                            for (var _j = tslib_1.__values(mapServer.mapServerFolders), _k = _j.next(); !_k.done; _k = _j.next()) {
                                var mapServerFolder = _k.value;
                                var serverFolderItem = {
                                    expanded: false,
                                    isSelected: false,
                                    name: mapServerFolder.name,
                                    layerCatalogItems: []
                                };
                                if (mapServerFolder.services) {
                                    try {
                                        for (var _l = tslib_1.__values(mapServerFolder.services), _m = _l.next(); !_m.done; _m = _l.next()) {
                                            var service = _m.value;
                                            var serviceItem = {
                                                expanded: false,
                                                isSelected: false,
                                                name: service.name,
                                                layerCatalogItems: [],
                                                description: service.description || service.serviceDescription
                                            };
                                            try {
                                                for (var _o = tslib_1.__values(service.layers), _p = _o.next(); !_p.done; _p = _o.next()) {
                                                    var layer = _p.value;
                                                    var layerItem = {
                                                        expanded: false,
                                                        isSelected: false,
                                                        name: layer.name,
                                                        layer: {
                                                            name: layer.name,
                                                            url: service.url + "/" + layer.id,
                                                            id: layer.id
                                                        }
                                                    };
                                                    serviceItem.layerCatalogItems.push(layerItem);
                                                }
                                            }
                                            catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                            finally {
                                                try {
                                                    if (_p && !_p.done && (_d = _o.return)) _d.call(_o);
                                                }
                                                finally { if (e_4) throw e_4.error; }
                                            }
                                            serverFolderItem.layerCatalogItems.push(serviceItem);
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (_m && !_m.done && (_c = _l.return)) _c.call(_l);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                                catalogItem.layerCatalogItems.push(serverFolderItem);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    if (mapServer.services) {
                        try {
                            for (var _q = tslib_1.__values(mapServer.services), _r = _q.next(); !_r.done; _r = _q.next()) {
                                var service = _r.value;
                                var serviceItem = {
                                    expanded: false,
                                    isSelected: false,
                                    name: service.name,
                                    layerCatalogItems: [],
                                    description: service.description || service.serviceDescription
                                };
                                try {
                                    for (var _s = tslib_1.__values(service.layers), _t = _s.next(); !_t.done; _t = _s.next()) {
                                        var layer = _t.value;
                                        var layerItem = {
                                            expanded: false,
                                            isSelected: false,
                                            name: layer.name,
                                            layer: {
                                                name: layer.name,
                                                url: service.url + "/" + layer.id,
                                                id: layer.id
                                            }
                                        };
                                        serviceItem.layerCatalogItems.push(layerItem);
                                    }
                                }
                                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                finally {
                                    try {
                                        if (_t && !_t.done && (_f = _s.return)) _f.call(_s);
                                    }
                                    finally { if (e_6) throw e_6.error; }
                                }
                                catalogItem.layerCatalogItems.push(serviceItem);
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_r && !_r.done && (_e = _q.return)) _e.call(_q);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                    this.catalogItems.push(catalogItem);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (this.catalogItems && this.catalogItems.length) {
            this.catalogItems.forEach(this.configureItemLevel.bind(this));
        }
    };
    ExternalLayerCatalogComponent.prototype.configureItemLevel = function (item) {
        var _a;
        if (!item.layer && item.layerCatalogItems) { // Is a group
            for (var i = item.layerCatalogItems.length - 1; i >= 0; i--) {
                var subItem = item.layerCatalogItems[i];
                this.configureItemLevel(subItem);
                if (!subItem.layer && (subItem.name === item.name || subItem.layerCatalogItems.length === 1)) { // Same name as parent or only 1 item, move it's items up
                    if (subItem.layerCatalogItems.length === 1) { // Only 1 item, use parent's name
                        subItem.layerCatalogItems[0].name = subItem.name;
                    }
                    (_a = item.layerCatalogItems).push.apply(_a, tslib_1.__spread(subItem.layerCatalogItems));
                    item.layerCatalogItems.splice(i, 1);
                }
            }
        }
    };
    ExternalLayerCatalogComponent.prototype.itemSelectedChanged = function (catalogItem) {
        var _this = this;
        var e_7, _a;
        if (this.selectedLayers && this.selectedLayers.length > 0) {
            try {
                for (var _b = tslib_1.__values(this.selectedLayers.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = tslib_1.__read(_c.value, 2), index = _d[0], item = _d[1];
                    if (!item.isSelected) {
                        this.selectedLayers.splice(index, 1);
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        var addToSelected = function (item) {
            if (item && item.layer && item.isSelected && !_this.selectedLayers.some(function (sl) { return sl.layer.url === item.layer.url; })) {
                _this.selectedLayers.push(item);
            }
            if (item.layerCatalogItems) {
                item.layerCatalogItems.forEach(addToSelected);
            }
        };
        catalogItem.layerCatalogItems.forEach(addToSelected);
    };
    ExternalLayerCatalogComponent.prototype.close = function () {
        this.featureLayerCatalog = null;
        this.catalogItems = [];
        this.filteredCatalogItems = [];
        this.selectedLayers = [];
        this.active = false;
        this.errorLoadingLayers = null;
        this.onclose.emit();
    };
    ExternalLayerCatalogComponent.prototype.filterCatalogItems = function (layerCatalogItems) {
        var e_8, _a;
        var copyOfArray = layerCatalogItems.concat([]);
        var newArray = [];
        try {
            for (var copyOfArray_1 = tslib_1.__values(copyOfArray), copyOfArray_1_1 = copyOfArray_1.next(); !copyOfArray_1_1.done; copyOfArray_1_1 = copyOfArray_1.next()) {
                var layerCatalogItem = copyOfArray_1_1.value;
                var currentItem = null;
                if (layerCatalogItem.layer) {
                    currentItem = layerCatalogItem;
                }
                else {
                    currentItem = tslib_1.__assign({}, layerCatalogItem);
                }
                if ((currentItem.layer && currentItem.layer.id.toString() === this.searchText)
                    || (currentItem.isSelected || !this.searchText || this.isNameAMatchToSearchText(currentItem.name))) {
                    newArray.push(currentItem);
                }
                if (currentItem.layerCatalogItems) {
                    if (newArray.indexOf(currentItem) < 0) {
                        currentItem.layerCatalogItems = this.filterCatalogItems(currentItem.layerCatalogItems);
                        if (this.searchText) {
                            currentItem.expanded = currentItem.layerCatalogItems.length > 0;
                        }
                    }
                }
                if (newArray.indexOf(currentItem) < 0 && currentItem.layerCatalogItems && currentItem.layerCatalogItems.length > 0) {
                    newArray.push(currentItem);
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (copyOfArray_1_1 && !copyOfArray_1_1.done && (_a = copyOfArray_1.return)) _a.call(copyOfArray_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
        return newArray;
    };
    ExternalLayerCatalogComponent.prototype.isNameAMatchToSearchText = function (name) {
        var e_9, _a;
        var allTermsFound = true;
        try {
            for (var _b = tslib_1.__values(this.searchText.toLowerCase().split(' ')), _c = _b.next(); !_c.done; _c = _b.next()) {
                var term = _c.value;
                allTermsFound = allTermsFound && name.toLowerCase().indexOf(term) >= 0;
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_9) throw e_9.error; }
        }
        return allTermsFound;
    };
    ExternalLayerCatalogComponent.prototype.addSelectedLayers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_10, _a, loadingPromises, _loop_1, _b, _c, selected;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        loadingPromises = [];
                        _loop_1 = function (selected) {
                            loadingPromises.push((function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var layerProps, error_2;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.layerService.getExternalServiceProperties({ url: selected.layer.url })];
                                        case 1:
                                            layerProps = _a.sent();
                                            return [2 /*return*/, this.layerService.addExternalLayersToMap(layerProps)];
                                        case 2:
                                            error_2 = _a.sent();
                                            this.loggingService.Log("Error Loading External Layer '" + selected.name + "'", error_2, LogLevel.Error);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })());
                        };
                        try {
                            for (_b = tslib_1.__values(this.selectedLayers), _c = _b.next(); !_c.done; _c = _b.next()) {
                                selected = _c.value;
                                _loop_1(selected);
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        this.loadingLayers = true;
                        this.cdr.detectChanges();
                        return [4 /*yield*/, Promise.all(loadingPromises)];
                    case 1:
                        _d.sent();
                        this.loadingLayers = false;
                        this.close();
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ExternalLayerCatalogComponent;
}(BaseComponent));
export { ExternalLayerCatalogComponent };
